import api from "api";
import { call, put, takeLatest } from "redux-saga/effects";

import { roles } from "../actions";
import { FETCH_ROLES_START } from "../constants";
import { fetchPagedSagaFactory } from "./utils";

export const rolesSaga = fetchPagedSagaFactory(
  api.Roles.get,
  roles.success,
  roles.failed
);

export function* fetchRoleByLabelSaga(label) {
  try {
    const { response } = yield call(api.Roles.getByLabel, label);
    yield put(roles.success(response));
    return response;
  } catch (error) {
    yield put(roles.failed(error));
    return undefined;
  }
}

export function* watchRoles() {
  yield takeLatest(FETCH_ROLES_START, rolesSaga);
}
